<div *ngIf="users?.length != 0">
  <app-details-divider></app-details-divider>
  <div *ngIf="label" class="ms-3 hstack my-4 gap-3">
    <app-dea-label [label]="label"></app-dea-label>
  </div>
  <div class="mb-4" *ngFor="let user of users;">
    <app-user-base-data [showFullData]="false" [showArrow]="true" [user]="user"></app-user-base-data>
  </div>
</div>